import React from "react";
import { EditField } from "../types";
import { ThemeFontValue } from "../../../api/widgetThemeApi";
import colors from "../../../colors/colors";

interface FontFieldProps {
  value: string;
  onChange: (value: string) => void;
  field: EditField;
  themeFonts: Record<string, ThemeFontValue>;
}

export const FontField: React.FC<FontFieldProps> = ({
  value,
  onChange,
  themeFonts,
}) => {
  return (
    <select
      value={value || "inherit"}
      onChange={(e) => onChange(e.target.value)}
      className="edit-panel-select"
      style={{
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${colors.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: colors.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: colors.white,
        cursor: "pointer",
        outline: "none",
        appearance: "none",
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 12px center",
        paddingRight: "36px",
      }}
    >
      <option value="inherit">Inherit (System Font)</option>
      {Object.entries(themeFonts).map(([fontKey, fontValue]) => (
        <option key={fontKey} value={fontKey}>
          {fontValue.name}
        </option>
      ))}
    </select>
  );
};

